<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20 mg-bottom30">
        <pageTitle :title="$t('detail')" :butShow="true"></pageTitle>
        <!-- <Row class="mg-bottom20" v-if="info.status == 0">
          <Poptip
            placement="bottom"
            confirm
            :title="$t('confirm_apply_agree')"
            @on-ok="handleApplyAgree()"
          >
            <Button class="btn" type="primary">{{$t("apply_agree")}}</Button>
          </Poptip>
          <Button class="btn" @click="affirmReject()">{{$t("apply_reject")}}</Button>
        </Row>-->
        <myDetailCell :info="labels" :title="$t('teacher_record.base_info')">
          <template v-slot:plan="{ data }">
            <div class="salary">
              <div>{{ data.value.renewal_cname }}</div>
            </div>
          </template>
          <template v-slot:avartar="{ data }">
            <div class="demo-upload-list" v-if="data.value">
              <template>
                <img :src="data.value" />
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(data.value)"></Icon>
                </div>
              </template>
            </div>
          </template>
          <template v-slot:plan_two="{ data }">
            <div class="salary">
              <div class="hkd">{{ "HKD" }}</div>
              <div class="mg-left10">{{ data.value_two.price }}</div>
            </div>
          </template>
        </myDetailCell>
      </div>
      <div class="table-box pd-20 mg-bottom30">
        <div class="table_title">{{$t('teacher_record.educational')}}</div>
        <Table :columns="columns" :data="data">
          <template slot-scope="{ row }" slot="date_begin">
            <span>{{row.date_begin + ' - ' + row.date_end}}</span>
          </template>
        </Table>
      </div>
      <div class="table-box pd-20 mg-bottom30">
        <div class="table_title">{{$t('teacher_record.workExperience')}}</div>
        <Table :columns="columns2" :data="data2">
          <template slot-scope="{ row }" slot="date_begin">
            <span>{{row.date_begin + ' - ' + row.date_end}}</span>
          </template>
        </Table>
      </div>
      <div class="table-box pd-20 mg-bottom30">
        <div class="table_title">{{$t('teacher_record.otherInfo')}}</div>
        <Table :columns="columns3" :data="data3">
          <template slot-scope="{ row }" slot="file_lnk">
            <a @click="linkDownload(row.file_lnk)">查看</a>
          </template>
        </Table>
      </div>
      <div class="table-box pd-20 mg-bottom30">
        <div class="table_title">{{$t('page_title.cent_list')}}</div>
        <myTable
          ref="table2"
          :columns="columns4"
          requestUrl="cent/list"
          :showPage="true"
          :params="{member_id: member_id}"
        ></myTable>
      </div>
    </div>
    <Modal
      v-model="modal"
      :title="$t('confirm_apply_reject')"
      @on-ok="handleApplyReject()"
      @on-cancel="modal = false"
      :loading="modalLoading"
    >
      <div class="modal_con">
        <Input
          v-model="reject_content"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4 }"
          :placeholder="$t('server_no_rw_remark')"
        />
      </div>
    </Modal>
    <Modal :title="$t('view_img')" v-model="visible">
      <img :src="imgName" v-if="visible" style="width: 100%" />
    </Modal>
  </div>
</template>

<script>
import myDetailCell from '@/components/myDetailCell'
import myTable from '@/components/myTable'
import pageTitle from "@/components/pageTitle";
export default {
  name: "",
  components: {
    myDetailCell,
    myTable,
    pageTitle
  },
  data () {
    return {
      id: this.$base.getRequest().id,
      member_id: "",
      pen: require('@/assets/img/pen.png'),
      info: {},
      labels: [],
      modal: false,
      reject_content: "",
      modalLoading: true,
      imgName: "",
      visible: false,
      columns: [
        { title: this.$t('teacher_record.year'), slot: 'date_begin' },
        { title: this.$t('home.school'), key: 'school_name' },
        { title: this.$t('teacher_record.subject'), key: 'subject_title' }
      ],
      columns2: [
        { title: this.$t('teacher_record.year'), slot: 'date_begin' },
        { title: this.$t('company'), key: 'company_name' },
        { title: this.$t('zhiwei'), key: 'job_title' },
        { title: this.$t('salary'), key: 'last_salary' }
      ],
      columns3: [
        { title: this.$t('upload_file_name'), key: 'file_name' },
        { title: this.$t('click_view'), slot: 'file_lnk' },
      ],
      columns4: [
        {
          title: this.$t("Info.code"),
          tooltip: true,
          key: "member_id",
          align: "center"
        },
        {
          title: this.$t("order_code"),
          tooltip: true,
          key: "order_no",
          align: "center"
        },
        {
          title: this.$t("cent.time"),
          tooltip: true,
          key: "add_time",
          align: "center"
        },
        {
          title: this.$t("cent.expire_time"),
          tooltip: true,
          key: "expire_time",
          align: "center"
        },
        {
          title: this.$t("user"),
          tooltip: true,
          key: "member_cname",
          align: "center"
        },
        {
          title: this.$t("role"),
          tooltip: true,
          key: "role_cdesc",
          align: "center"
        },
        {
          title: this.$t("cent.integral"),
          tooltip: true,
          key: "in_count",
          align: "center"
        },
        {
          title: this.$t("cent.employ"),
          tooltip: true,
          key: "type_cdesc",
          align: "center"
        },
        {
          title: this.$t("status"),
          tooltip: true,
          key: "status_cdesc",
          align: "center"
        }
      ],
      data: [],
      data2: [],
      data3: [],
    }
  },
  mounted () {
    this.getTeacherDetail();
  },
  methods: {
    getTeacherDetail () {
      this.$base.showLoading();
      this.$request.sendPost(
        "teacher/before-upd",
        { teacher_id: this.id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.info = data.info;
          this.data = this.info.educates
          this.data2 = this.info.works
          this.data3 = this.info.files
          console.log(this.info, "this.info");
          this.labels = [
            { label: this.$t("teacher_record.id"), value: this.info.teacher_id },
            { label: this.$t("teacher_record.avartar"), value: this.info.teacher_avartar, slot: "avartar" },
            { label: this.$t("teacher_record.name"), value: this.info.teacher_cname },
            { label: this.$t("teacher_record.alias"), value: this.info.teacher_alias },
            { label: this.$t("teacher_record.phone"), value: this.info.contact_mobile },
            { label: this.$t("teacher_record.email"), value: this.info.teacher_email },
            { label: this.$t("teacher_record.join_time"), value: this.info.add_time },
            {
              label: this.$t("vip_payment_plan"), value: this.info.renewal, slot: "plan",
              value_two: this.info.renewal, slot_two: "plan_two"
            },
            { label: this.$t("vip_due_time"), value: this.info.renewal_time },
            {label: this.$t("cent.integral"),value: this.info.cent_remain},
            {label: this.$t("cent.cent_expire_time"),value: this.info.last_expire}
          ];
            this.$refs.table2.reSearch({ member_id: this.info.member_id });
        }
      );
    },
    linkDownload (url) {
      window.open(url, '_blank') // 新窗口打开外链接
    },
    affirmReject () {
      this.reject_content = "";
      this.modal = true;
    },
    handleApplyAgree () {
      this.$base.showLoading();
      this.$request.sendPost(
        "teacher/com",
        { teacher_id: this.id, status: 1 },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          this.$base.linkBack();
        }
      );
    },

    handleApplyReject () {
      if (this.reject_content == "") {
        setTimeout(() => {
          this.modalLoading = false;
          this.$nextTick(() => {
            this.modalLoading = true;
          });
        }, 1000);
        return this.$base.msgErr(this.$t("no_server_rw_remark"));
      }
      this.$base.showLoading();
      this.$request.sendPost(
        "teacher/reject",
        { teacher_id: this.id, reject_content: this.reject_content },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) {
            this.$base.msgErr(error.errmsg);
            return this.modal = false;
          }
          this.$base.msgSuccess(this.$t("op_ok"));
          this.modal = false;
          this.$base.linkBack();

        }
      );
    },
    handleEdit (item) {
      console.log(item.value)
    },
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    },
  },
}
</script>

<style lang="less" scoped>
.item {
  padding: 10px 0;
  display: flex;
}
.check {
  color: var(--green_one);
  font-size: 14px;
}
/deep/ .table-box {
  .salary {
    padding-left: 8px;
    display: flex;
    align-items: center;
  }
  .ivu-table th {
    background-color: #09684a;
    color: #fff;
    padding: 10px 0;
  }
  .table_title {
    font-size: 18px;
    padding: 0 20px 10px 0;
    font-weight: bold;
  }
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
  .check {
    color: var(--green_one);
    font-size: 14px;
  }
  .btn {
    font-size: 14px;
    margin-right: 10px;
  }
  .demo-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover {
    display: block;
  }
  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/teacher/record/detail.vue